












































import Vue from 'vue';
import { mapMutations, mapGetters } from 'vuex';

import { iconsMixin } from '@/mixins/icons';
import { breakpointsMixin } from '@/mixins/breakpoints';
import { authMixin } from '@/mixins/auth';

import miscService from '@/services/MiscService';
import quoteService from '@/services/QuoteService';
import mileageService from '@/services/MileageService';

export default Vue.extend<any, any, any, any>({
  mixins: [iconsMixin, breakpointsMixin, authMixin],
  data() {
    return {
      quote: null,
      mileage: 'N/A',
      blob: null,
      showLoadingScreen: false,
      showCustomDownloadIcon: false,
      allDataLoaded: false,
    };
  },
  mounted() {
    document.title = 'Quote Details - ' + this.$route.params.quoteId;
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.startLoading('Loading quote details...');

      quoteService.getById(this.$route.params.quoteId).then((x) => {
        this.startLoading('Calculating miles...');
        mileageService
          .getMiles(x.origZip as any, x.destZip as any)
          .then((m) => {
            this.mileage = m?.miles ?? 'N/A';
          })
          .finally(() => {
            this.quote = x;

            miscService.runWithDelay(() => {
              this.initPdfRendering();
            }, 200);
          });
      });
    },
    initPdfRendering() {
      this.stopLoadingAndRenderQuote();
    },
    stopLoadingAndRenderQuote() {
      this.$refs.html2Pdf.generatePdf();
      this.stopLoading();
    },
    startLoading(message) {
      this.showLoadingScreen = true;
      this.loadingScreenMessage = message;
    },
    stopLoading() {
      this.showLoadingScreen = false;
      this.loadingScreenMessage = null;
    },
    /* istanbul ignore next */
    async beforeDownload({ html2pdf, options, pdfContent }) {
      options.pagebreak = { mode: 'avoid-all' };
      this.blob = await html2pdf()
        .set(options)
        .from(pdfContent)
        .toPdf()
        .output('blob')
        .then((data: Blob) => {
          return data;
        });
    },
    /* istanbul ignore next */
    downloadFile() {
      const link = document.createElement('a');
      link.href = URL.createObjectURL(this.blob);
      link.download = this.fileName;
      document.body.append(link);
      link.click();
      link.remove();
      setTimeout(() => URL.revokeObjectURL(link.href), 7000);
    },
    /* istanbul ignore next */
    hasDownloaded() {
      setTimeout(() => {
        this.showCustomDownloadIcon = true;
      }, 500);
    },
  },
  computed: {
    fileName() {
      return this.$route.params.quoteId;
    },
    quoteJson() {
      return this.quote;
    },
    showLoadingScreenComputed() {
      return this.showLoadingScreen;
    },
    mileageJson() {
      return this.mileage;
    },
  },
});
